
import Main from '../main/Main.js'

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
